module.exports = __webpack_public_path__ + "img/lv2_2_1.4068d974.png";